import Mustache from 'mustache';

type ResolveOptions = {
  /**
   * Escape HTML entities in `{{var}}` substitutions.
   * Default: true (Mustache's normal behavior).
   * Set false to render everything raw, like `{{{var}}}`.
   */
  escape?: boolean;
};

export const slugify = (v: string) => {
  return v
    .toLowerCase()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
};

export const resolveMustacheString = (
  template: string,
  contextData: unknown,
  options: ResolveOptions = {},
) => {
  const { escape = true } = options;

  if (escape) {
    return Mustache.render(template, contextData);
  }

  // Render with escaping disabled: swap escape fn for identity.
  const originalEscape = (Mustache as any).escape;
  (Mustache as any).escape = (value: string) => value;
  try {
    return Mustache.render(template, contextData);
  } finally {
    (Mustache as any).escape = originalEscape;
  }
};
